import { useMutation } from '@tanstack/react-query';

import { PrependUrl } from 'enums';
import { fetchWithCsrfToken } from 'utils/fetchWrapper';

interface IUpdateAssessmentDeadlinesVariables {
  interviewUid: string;
  startDate: string;
  closedDate: string | null;
  isEnable: boolean;
  interval: number | null;
  timeZone: string;
}

interface IUpdateAssessmentDeadlineResponse {
  uid: string;
  start_date: string;
  closed_date: string;
  has_rolling_applicant_deadline: boolean;
  rolling_applicant_deadline: number;
  interview_time_zone: string;
}

const useUpdateAssessmentDeadline = () => {
  const {
    mutateAsync: updateAssessmentDeadline,
    data,
    isLoading,
    error,
  } = useMutation<
    IUpdateAssessmentDeadlineResponse,
    Error,
    IUpdateAssessmentDeadlinesVariables
  >(
    ['updateAssessmentDeadline'],
    async ({
      interviewUid,
      startDate,
      closedDate,
      isEnable,
      interval,
      timeZone,
    }) => {
      const body = {
        interview: interviewUid,
        start_date: startDate,
        closed_date: closedDate,
        has_rolling_applicant_deadline: isEnable,
        rolling_applicant_deadline: interval,
        interview_time_zone: timeZone,
      };

      const assessment =
        await fetchWithCsrfToken<IUpdateAssessmentDeadlineResponse>(
          `${PrependUrl.ASYNC}/assessment/update_deadline`,
          'POST',
          body
        );

      return assessment;
    }
  );

  return {
    updateAssessmentDeadline,
    data,
    isLoading,
    error,
  };
};

export default useUpdateAssessmentDeadline;
